{
  "DATE_PICKER": {
    "APPLY_BUTTON": "Primijeni",
    "CLEAR_BUTTON": "Očisti",
    "DATE_RANGE_INPUT": {
      "START": "Datum početka",
      "END": "Datum završetka"
    },
    "DATE_RANGE_OPTIONS": {
      "TITLE": "RASPON DATUMA",
      "TODAY": "Danas",
      "YESTERDAY": "Jučer",
      "LAST_7_DAYS": "Zadnjih 7 dana",
      "LAST_30_DAYS": "Zadnjih 30 dana",
      "LAST_3_MONTHS": "Zadnja 3 mjeseca",
      "LAST_6_MONTHS": "Zadnjih 6 mjeseci",
      "LAST_YEAR": "Prošla godina",
      "CUSTOM_RANGE": "Prilagođeni raspon datuma"
    }
  }
}
